import InitApi from "api/InitApi";
import ServerErrors from "components/SeverErrors";
import toast from "react-hot-toast";
import { useMutation } from "react-query";
import { reactLocalStorage } from "reactjs-localstorage";
import useTokenStore from "store/tokenStore";

const useReconcileEcocashOrders = () => {
	const { accessToken } = useTokenStore();

	const reconcile = async (hours = 48) => {
		const instance = await InitApi({ accessToken });

		const res = await instance.post("/orders/reconcile-ecocash", { hours });

		return res.data;
	};

	return useMutation(reconcile, {
		onSuccess: async (data) => {
			const result = data?.data;
			if (result?.recovered > 0) {
				toast.success(`Reconciliation complete: ${result.recovered} order(s) recovered`, {
					duration: 5000,
				});
			} else {
				toast.success("Reconciliation complete: No orders needed recovery", {
					duration: 3000,
				});
			}
		},
		onError: async (error) => {
			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message}
					errors={error?.response?.data?.data}
				/>,
				{
					className: "max-w-max",
				}
			);

			if (error?.response?.data.message === "Unauthenticated.") {
				reactLocalStorage.clear();
			}
		},
	});
};

export default useReconcileEcocashOrders;
